import { render, staticRenderFns } from "./seventhLogoRow.vue?vue&type=template&id=36153ff0&"
import script from "./seventhLogoRow.vue?vue&type=script&lang=js&"
export * from "./seventhLogoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports